import { createFileRoute } from '@tanstack/react-router';

import { TeamForm } from '../-components/TeamForm';

export const Route = createFileRoute('/_authenticated/teams/soccerTeams/new')({
    component: () => <TeamForm sportType="soccer" />,
});
